import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

type Props = {
  selectedType: string;
  setSelectedType: (selectedType: string) => void;
  /** embedded = compact row in parent toolbar; standalone = legacy spacing in forms */
  variant?: "embedded" | "standalone";
};

const Type = ({
  selectedType,
  setSelectedType,
  variant = "standalone",
}: Props) => {
  const handleChange = (e: SelectChangeEvent) => {
    setSelectedType(e.target.value);
  };

  const embedded = variant === "embedded";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        ...(embedded ? { mr: 0, mb: 0 } : { mr: 2, mb: 2 }),
      }}>
      <FormControl size="small" sx={{ minWidth: { xs: 200, sm: 200 } }}>
        <InputLabel id="clinical-record-type-label">
          Clinical record type
        </InputLabel>
        <Select
          labelId="clinical-record-type-label"
          id="clinical-record-type-select"
          label="Clinical record type"
          value={selectedType}
          onChange={(e) => handleChange(e)}>
          <MenuItem value={"eye_examination"}>Eye Examination</MenuItem>
          <MenuItem value={"contact_lenses"}>Contact Lenses</MenuItem>
          <MenuItem value={"diabetic_eye_screening"}>
            Diabetic Eye Screening
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default Type;
